<template>
  <div class="scorllPlace">
    <div @touchend="moveEnd" @touchmove="moveImg" @touchstart="starMove" :id="randomId + '-imgPlace'" class="scorllImgHidden">
      <div class="dotPlace">
        <div :key="index" :class="nowIndex === index ? 'active' : ''" v-for="(item, index) in newImgList"></div>
      </div>
    </div>
    <img :src="item" :key="index" style="width: 0;height: 0" v-for="(item, index) in newImgList" />
  </div>
</template>

<script>
let pageX = 0
export default {
  name: 'page',
  props: [
    'imgList'
  ],
  data () {
    return {
      randomId: new Date().getTime() + Math.random() * 9999,
      nowIndex: 0,
      newImgList: this.imgList,
      imgWidth: 0
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行

  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    if (this.newImgList.length > 0) {
      let imgDom = document.createElement('img')
      imgDom.src = this.newImgList[this.newImgList.length - 1]
      imgDom.style.width = '100%'
      imgDom.style.left = '-100%'
      imgDom.style.top = '0'
      imgDom.style.position = 'absolute'
      imgDom.style.transform = 'translateX(0px)'
      imgDom.setAttribute('data-trans', '0')
      let imgDom2 = document.createElement('img')
      imgDom2.src = this.newImgList[0]
      imgDom2.style.width = '100%'
      imgDom2.style.top = '0'
      imgDom2.style.left = '0'
      imgDom2.style.position = 'relative'
      imgDom2.style.transform = 'translateX(0px)'
      imgDom2.setAttribute('data-trans', '0')
      let imgDom3 = document.createElement('img')
      imgDom3.src = this.newImgList[1] || this.newImgList[0]
      imgDom3.style.width = '100%'
      imgDom3.style.left = '100%'
      imgDom3.style.top = '0'
      imgDom3.style.position = 'absolute'
      imgDom3.style.transform = 'translateX(0px)'
      imgDom3.setAttribute('data-trans', '0')
      document.getElementById(this.randomId + '-imgPlace').appendChild(imgDom)
      document.getElementById(this.randomId + '-imgPlace').appendChild(imgDom2)
      document.getElementById(this.randomId + '-imgPlace').appendChild(imgDom3)
    }
  },
  methods: { // 所有的方法封装
    starMove (e) {
      pageX = e.touches[0].clientX
    },
    moveImg (e) {
      // let aPos = domList[i].style.transform.indexOf('(')
      // let bPos = domList[i].style.transform.indexOf('px)')
      // let newName = parseInt(domList[i].style.transform.substr(aPos + 1, bPos - aPos - 1))
      let dom = document.getElementById(this.randomId + '-imgPlace')
      let domList = dom.querySelectorAll('img')
      this.imgWidth = domList[0].clientWidth
      for (let i = 0; i < domList.length; i++) {
        let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
        domList[i].style.transform = 'translateX(' + (nowtrans + e.touches[0].clientX - pageX) + 'px)'
      }
    },
    moveEnd (e) {
      let dom = document.getElementById(this.randomId + '-imgPlace')
      let domList = dom.querySelectorAll('img')
      for (let i = 0; i < domList.length; i++) {
        domList[i].style.transition = 'all 0.3s'
      }
      setTimeout(p => {
        for (let i = 0; i < domList.length; i++) {
          domList[i].style.transition = 'width 0.3s'
        }
      }, 300)
      if (Math.abs(e.changedTouches[0].clientX - pageX) > 80) {
        if (e.changedTouches[0].clientX > pageX) {
          for (let i = 0; i < domList.length; i++) {
            let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
            domList[i].style.transform = 'translateX(' + (nowtrans + this.imgWidth) + 'px)'
            domList[i].setAttribute('data-trans', nowtrans + this.imgWidth)
          }
          this.nowIndex--
          if (this.nowIndex < 0) {
            this.nowIndex = this.newImgList.length - 1
          }
          setTimeout(p => {
            domList[1].style.position = 'absolute'
            domList[1].style.left = '-' + (Math.abs(parseInt(domList[1].getAttribute('data-trans'))) - this.imgWidth) + 'px'
            domList[0].style.position = 'relative'
            domList[0].style.left = '-' + parseInt(domList[0].getAttribute('data-trans')) + 'px'
            let imgDom3 = document.createElement('img')
            imgDom3.src = this.newImgList[this.nowIndex - 1] || this.newImgList[this.newImgList.length - 1]
            imgDom3.style.width = '100%'
            imgDom3.style.left = '-' + this.imgWidth + 'px'
            imgDom3.style.top = '0'
            imgDom3.style.position = 'absolute'
            imgDom3.style.transform = 'translateX(0px)'
            imgDom3.setAttribute('data-trans', '0')
            document.getElementById(this.randomId + '-imgPlace').insertBefore(imgDom3, domList[0])
            domList[2].remove()
          }, 300)
        } else {
          for (let i = 0; i < domList.length; i++) {
            let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
            domList[i].style.transform = 'translateX(' + (nowtrans - this.imgWidth) + 'px)'
            domList[i].setAttribute('data-trans', nowtrans - this.imgWidth)
          }
          this.nowIndex++
          if (this.nowIndex === this.newImgList.length) {
            this.nowIndex = 0
          }
          setTimeout(p => {
            domList[1].style.position = 'absolute'
            domList[1].style.left = (Math.abs(parseInt(domList[1].getAttribute('data-trans'))) - this.imgWidth) + 'px'
            domList[2].style.position = 'relative'
            domList[2].style.left = Math.abs(parseInt(domList[2].getAttribute('data-trans'))) + 'px'
            let imgDom3 = document.createElement('img')
            imgDom3.src = this.newImgList[this.nowIndex + 1] || this.newImgList[0]
            imgDom3.style.width = '100%'
            imgDom3.style.left = '100%'
            imgDom3.style.top = '0'
            imgDom3.style.position = 'absolute'
            imgDom3.style.transform = 'translateX(0px)'
            imgDom3.setAttribute('data-trans', '0')
            document.getElementById(this.randomId + '-imgPlace').appendChild(imgDom3)
            domList[0].remove()
          }, 300)
        }
      } else {
        for (let i = 0; i < domList.length; i++) {
          let nowtrans = parseInt(domList[i].getAttribute('data-trans'))
          domList[i].style.transform = 'translateX(' + nowtrans + 'px)'
        }
      }
    },
    resetImg () {
      // let dom = document.getElementById(this.randomId + '-imgPlace')
      // let domList = dom.querySelectorAll('img')
      // domList[0].src = this.newImgList[this.nowIndex - 1] || this.newImgList[this.newImgList.length - 1]
      // domList[1].src = this.newImgList[this.nowIndex]
      // domList[2].src = this.newImgList[this.nowIndex + 1] || this.newImgList[0]
      // for (let i = 0; i < domList.length; i++) {
      //   // domList[i].style.transform = 'translate(' + 0 + 'px, 0)'
      // }
    }
  },
  components: {
  },
  watch: {
    imgList (value) {
      this.newImgList = value
    }
  }
}
</script>

<style scoped>
  .scorllPlace {
    width: 100%;
    overflow: hidden;
    position: relative;
  }
  .scorllPlace img {
    width: 100%;
  }
  .scorllImgHidden{
    white-space: nowrap;
    left: 0;
    position: relative;
  }
  .dotPlace{
    position: absolute;
    z-index: 2;
    bottom: 5%;
    width: 100%;
    text-align: center;
  }
  .dotPlace > div{
    display: inline-block;
    width: 5px;
    margin: 0 3px;
    height: 5px;
    opacity: 0.8;
    border-radius: 5px;
    transition: all 0.3s;
    background-color: #fff;
  }
  .dotPlace > div.active{
    width: 10px;
    background-color: #4A85E8;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/imgScorll.vue